<div class="row">
  <div class="col">

    <div class="box box-primary">

      <div class="box-header text-center">
        <h3 class="box-title ">SSs aguardando Aprovação</h3><br />
        <span class="text-muted" *ngIf="this.listaSpvsAbertas?.length > 0">clique na SS a ser avaliada</span>
      </div>

      <div class="box-body">

        <div class="box-table h450" *ngIf="this.listaSpvsAbertas?.length > 0">


          <table>
            <thead>
              <tr>
                <th>Nº SS</th>
                <th>Serviço Solicitado</th>
                <th>Requisitante</th>
                <th>Elaborado por</th>
                <th>Ramal</th>
                <th>Localizacao</th>
                <th>{{labelCentroCusto}}</th>
                <th>Data Solicitação</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let spv of this.listaSpvsAbertas" (click)="getById(spv?.id, modal)" class="cp">
                <td class="text-center">{{ spv?.id | zerosEsquerda : 5}}</td>
                <td>{{ spv?.servico }}</td>
                <td class="text-center">{{ spv?.requisitante }}</td>
                <td class="text-center">{{ spv?.usuarioSolicitou }}</td>
                <td class="text-center">{{ spv?.contato }}</td>
                <td>{{ spv?.localizacao }}</td>
                <td class="text-center">{{ spv?.centroCusto}}</td>
                <td class="text-center">{{ spv?.dataHoraCadastro | date:'dd/MM/yyyy' }}</td>
              </tr>
              <tr *ngFor="let v of this.voids">
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>


        </div>

        <div class="no-results mt-5  h450" *ngIf="this.listaSpvsAbertas !== undefined && this.listaSpvsAbertas?.length == 0">
          <div class="swal2-icon swal2-success swal2-animate-success-icon">
            <div class="swal2-success-circular-line-left" style="background-color: rgb(255, 255, 255);"></div>
            <span class="swal2-success-line-tip"></span><span class="swal2-success-line-long"></span>
            <div class="swal2-success-ring"></div>
            <div class="swal2-success-fix" style="background-color: rgb(255, 255, 255);"></div>
            <div class="swal2-success-circular-line-right" style="background-color: rgb(255, 255, 255);"></div>
          </div>
          <div class="results-subtitle">No momento</div>
          <div class="results-title">Nenhuma SS aguardando aprovação</div>
        </div>



      </div>
      <div class="box-footer">
        <span *ngIf="this.listaSpvsAbertas !== undefined && this.listaSpvsAbertas?.length > 0"
          class="pl-2 pt-1 pb-2">Total SSs: <b>{{ this.listaSpvsAbertas?.length  }}</b></span>
      </div>

    </div>
  </div>
</div>

<div class="row">
  <div class="col">
    <div class="box box-primary">
      <div class="box-body">
        <div class="row">
          <div class="col">
            <div class="d-flex justify-content-center">
              <a [routerLink]="['/home']" title="Tela Principal"><img src="./assets/images/homePeq.png" /></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- ********************************* MODAIS ********************************************** -->

<ng-template #modal let-c="close" let-d="dismiss">

  <div class="modal-header mh-primary">
    <h4 class="modal-title">Avaliação SS N° <b>{{ this.spvSelecionada?.id | zerosEsquerda : 5}}</b></h4>
  </div>
  <div class="modal-body pt-1">
  <div class="tarja-aviso" *ngIf="(this.statusSS != 'aberto')">
     <p><b><i class="fa fa-warning pr-2"></i>Atenção: </b> Esta SS já foi avalida por outro usuário</p> 
    </div>

    <div class="position-relative row form-group pt-3">
      <label class="col-md-3 col-form-label">Requisitante</label>
      <div class="col-md-4">
        <input class="form-control" type="text" value="{{ this.spvSelecionada?.requisitante }}" disabled>
      </div>
      <label class="col-md-2 col-form-label">Ramal</label>
      <div class="col-md-3">
        <input class="form-control" type="text" value="{{ this.spvSelecionada?.contato }}" disabled>
      </div>
    </div>

    <div class="position-relative row form-group">
      <label class="col-md-3 col-form-label">{{labelCentroCusto}}</label>
      <div class="col-md-4">
        <input class="form-control" type="text" value="{{ this.spvSelecionada?.centroCusto }}" disabled>
      </div>

     
    </div>

    <div class="position-relative row form-group">
      <label class="col-md-3 col-form-label">Localização</label>
      <div class="col-md-9">
        <input class="form-control" type="text" value="{{ this.spvSelecionada?.localizacao }}" disabled>
      </div>

     
    </div>

    <div class="divider"></div>
   

    <div class="position-relative row form-group">
      <label class="col-md-3 col-form-label">Serviço Solicitado</label>
      <div class="col-md-9">
        <div [formGroup]="formAprovar">
          <textarea rows="2" class="form-control" formControlName="servico" value="{{ this.spvSelecionada?.servico }}"
            form="formAprovar"></textarea>
        </div>
      </div>
    </div>
 

    <section style="border: 1px solid #ddd; margin-top: 15px; overflow-y: scroll; overflow-x: hidden;" 
      *ngIf="this.autorizacaoAdicionarFoto">
      <div class="form-row text-center" style="padding: 0 5px;">
        <div class="col-md-12 fb fs11" style="background-color: #eee; padding: 12px">Registro fotográfico</div>
      </div>

      <div class="row showImagens" style="padding-bottom: 20px; height: 120px;">
        <div class="col-md-2" *ngFor="let pview of previewsPhotos">
          <div>
            <img [src]="pview.dataUrl" class="zoom cp"
              (click)="openModalExibePhoto(modalExibePhoto, pview)">
          </div>
        </div>
      </div>

    </section>


    





    <div class="divider"> </div>


    <!-- ********************************** -->

    <ngb-tabset class="tabs-animated tabs-animated-shadow" justify="justified">
      <ngb-tab>

        <ng-template ngbTabTitle class="ngbTabTitle">
          <span><i class="fa fa-thumbs-o-up mr-5"></i>Aprovar SS</span>
        </ng-template>

        <ng-template ngbTabContent>

          <form novalidate [formGroup]="formAprovar" id="formAprovar" (validSubmit)="AprovarSubmit()">

            <!--1 -->
            <div class="position-relative row form-group">

              <label class="col-md-2 col-form-label">Grupo local</label>
              <div class="col-md-4">
                <select for="" class="form-control" formControlName="grupoLocalNivel1Id"
                  (change)="changeGrupoLocalNivel1()">
                  <option value="">selecione</option>
                  <option *ngFor="let t of this.niveis1" [value]="t.id">{{ t.nome }}</option>
                </select>
              </div>

              <label class="col-md-2 col-form-label" *ngIf="this.empreiteiras.length > 1">Empreiteira</label>
              <div class="col-md-4" *ngIf="this.empreiteiras.length >  1">
                <select class="form-control" formControlName="empreiteiraId" value="">
                  <option value="" *ngIf="this.empreiteiras.length >  1">selecione</option>
                  <option *ngFor="let e of empreiteiras" value="{{ e.id }}"  >{{ e.nome }}</option>
                </select>
                <section *ngIf="!formAprovar.valid" class="form-text text-danger pl-2">
                  <small *ngIf="formAprovar.get('empreiteiraId').hasError('invalidEmpreiteiraId')">Selecione a
                    Empreiteira</small>
                </section>
              </div>

            </div>
            <!--2 -->
            <div class="position-relative row form-group">

              <label class="col-md-2 col-form-label">Local <span class="field-required">(*)</span></label>
              <div class="col-md-4">
                <select class="form-control" #localId formControlName="localId" [ngClass]="{'h-error': formAprovar.get('localId').hasError('invalidLocalId')}"
                  (change)="getEquipamentoPorLocalId($event.target.value)">
                  <option value="">selecione</option>
                  <option *ngFor="let local of locaisPorNivel" [value]="local.id">{{ local.nome }}</option>
                </select>
                <section *ngIf="!formAprovar.valid" class="form-text text-danger pl-2">
                  <small *ngIf="formAprovar.get('localId').hasError('invalidLocalId')">O Local deve ser informado</small>
                </section>
              </div>

              <label class="col-md-2 col-form-label">Equipamento
                <span *ngIf="buscandoEquipamentos" class="ball-clip-rotate">
                  <div></div>
                </span>
              </label>
              <div class="col-md-4">


                <div class="input-group">
                  <select class="form-control" #equipamentoId formControlName="equipamentoId">
                    <option value="">selecione</option>
                    <option *ngFor="let eq of equipamentos" value="{{ eq.id }}">{{ eq.nome }}</option>
                  </select>

                  <div class="input-group-append cp">
                    <span class="input-group-text"
                      (click)="openModalCadastroEquipamento(localId.value, modalequipamento)"
                      title="Cadastro Equipamento"><i class="fa fa-plus-circle"></i></span>
                  </div>
                </div>
                <section *ngIf="!formAprovar.valid" class="form-text text-danger pl-2">
                  <small *ngIf="formAprovar.get('equipamentoId').hasError('invalidEquipamentoId')">O equipamento deve
                    ser informado</small>
                </section>

              </div>              
            </div>





            <!-- ******** -->
            <!-- 4-->
            <div class="position-relative row form-group">

              <label class="col-md-2 col-form-label">Tipo de OS<span class="field-required">(*)</span></label>
              <div class="col-md-4">
                <select class="form-control" formControlName="tipoOS" value="">
                  <option value="" selected>selecione</option>
                  <option *ngFor="let op of this.tipoOSFixas" [value]="op.codigo">{{op.descricao}}</option>
                  <option *ngFor="let op of this.tipoOSAdicionais" [value]="op.codigo">{{op.descricao}}</option>
                </select>
                <section *ngIf="!formAprovar.valid" class="form-text text-danger pl-2">
                  <small *ngIf="formAprovar.get('tipoOS').hasError('invalidTipoOs')">Selecione o Tipo de OS</small>
                </section>
              </div>

              <label class="col-md-2 col-form-label">Prioridade <span class="field-required">(*)</span></label>
              <div class="col-md-4">
                <select class="form-control" #prioridade formControlName="prioridadeId" value="">
                  <option value="" selected>selecione</option>
                  <option *ngFor="let pri of prioridades" [value]="pri.id">{{pri.descricao}}</option>
                </select>
                <section *ngIf="!formAprovar.valid" class="form-text text-danger pl-2">
                  <small *ngIf="formAprovar.get('prioridadeId').hasError('invalidPrioridade')">Selecione uma 
                    prioridade</small>
                </section>
              </div>
            </div>
            <!-- 5 -->
            <!--   <div class="position-relative row form-group">
            </div> -->


            <!-- *********** -->
            <div class="position-relative row form-group">

              <label class="col-md-2 col-form-label">Área Téc. <span class="field-required">(*)</span></label>
              <div class="col-md-4">

                <div class="input-group">
                  <select class="form-control" #areaTecnicaId formControlName="areaTecnicaId" value="">
                    <option value="" selected>selecione</option>
                    <option *ngFor="let at of areasTecnicas" value="{{ at.id }}">{{ at.nome }}</option>
                  </select>


                  <div class="input-group-append cp" (click)="openModalNovaAreaTecnica(modaloutraareatecnica)"
                    title="Cadastrar outro Área Técnica">
                    <span class="input-group-text"><i class="fa fa-plus-circle"></i></span>
                  </div>

                </div>
                <section *ngIf="!formAprovar.valid" class="form-text text-danger pl-2">
                  <small *ngIf="formAprovar.get('areaTecnicaId').hasError('invalidAreaTecnicaId')">Selecione a Área
                    Técnica</small>
                </section>
              </div>

              <div class="col-md-2"></div>
              <div class="col-md-4">
                <div class="d-flex justify-content-start">

                  <div class="custom-checkbox custom-control pt-2">
                    <input class="form-check-input" type="checkbox" id="areaRestrita" #areaRestrita
                      formControlName="areaRestrita" (change)="changeAreaRestrita(areaRestrita.checked)">
                    <label class="form-check-label" for="areaRestrita">Área restrita</label>
                  </div>
                </div>
              </div>

            </div>
            <div class="position-relative row form-group">
              <label class="col-md-2 col-form-label">Observações Gerais</label>
              <div class="col-md-10">
                <textarea rows="2" class="form-control" formControlName="observacoesGerais"></textarea>
              </div>
            </div>


            <div class="divider"></div>

            <div class="row">
              <div class="col-md-6"></div>
              <div class="col-md-2">
                <button type="button" class="btn btn-secondary btn-block"
                (click)="c('Close click')">Cancelar</button>
              </div>
              <div class="col-md-4">
                  <button type="submit" [disabled]="!this.autorizacoes?.podeIncluir || this.isProcessing || this.statusSS != 'aberto'"
                    class="btn btn-primary btn-block">Aprovar SS</button>
              </div>
            </div>

          </form>
        </ng-template>
      </ngb-tab>

      <!-- ********************************** -->
      <ngb-tab>
        <ng-template ngbTabTitle>
          <span><i class="fa fa-thumbs-o-down mr-5"></i>Recusar SS</span>
        </ng-template>
        <ng-template ngbTabContent>

          <form novalidate [formGroup]="formRecusar" id="formRecusar" (ngSubmit)="recusarSubmit()">
            <div class="row d-flex justify-content-center align-items-center mb-3 mt-2">
              <span class="modal-title">Justificativa da Recusa</span>
            </div>
            <div class="position-relative row form-group" style="min-height: 85px;">
              <div class="col-md-1"></div>
              <div class="col-md-10">
                <textarea rows="4" class="form-control" type="text" formControlName="justificativa" maxlength="250" 
                style="resize:none"></textarea>
              </div>
            </div>
            <div class="divider"></div>
            <div class="row">
              <div class="col-md-6">
                <div class="d-flex justify-content-start">
                  <span class="text-danger">(*) Preenchimento obrigatório</span>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex justify-content-end">
                  <button type="button" class="btn btn-secondary pl-4 pr-4 mr-2"
                    (click)="c('Close click')">Fechar</button>
                  <button type="submit" [disabled]="!this.autorizacoes?.podeIncluir || this.isProcessing || this.statusSS != 'aberto'"
                    class="btn btn-danger pl-4 pr-4">Recusar SS</button>
                </div>
              </div>
            </div>
          </form>
        </ng-template>
      </ngb-tab>
    </ngb-tabset>
  </div>
</ng-template>



<!-- CADASTRO EQUIPAMENTO -->

<ng-template #modalequipamento let-c="close" let-d="dismiss">

  <div class="modal-header">
    <h4 class="modal-title">Cadastro Equipamento</h4>
  </div>

  <div class="modal-body">


    <form novalidate [formGroup]="formEquipamento" id="formEquipamento" (validSubmit)="addEquipamento(c)">

      <!--  Campos ocultos e disables -->
      <select class="form-control" formControlName="centroCustoId" hidden>
        <option *ngFor="let cc of centrosDeCusto" value="{{ cc.id }}">{{ cc.nome }}</option>
      </select>

      <select class="form-control" formControlName="localId" hidden>
        <option *ngFor="let l of locaisPorNivel" value="{{ l.id }}">{{ l.nome }}</option>
      </select>
      <!--  /Campos ocultos e disables -->

      <div class="form-row">
        <div class="col-md-4">
          <div class="position-relative form-group">
            <label for="">Nome</label>
            <input class="form-control" type="text" formControlName="nome" maxlength="120" />
            <section *ngIf="!formEquipamento.valid" class="form-text text-danger pl-2">
              <small *ngIf="formEquipamento.get('nome').hasError('notUnique')">Nome de equipamento já utilizado</small>
            </section>
          </div>
        </div>
        <div class="col-md-8">
          <div class="position-relative form-group">
            <label for="">Nº de série</label>
            <input class="form-control" type="text" maxlength="15" formControlName="numeroSerie" />
            <section *ngIf="!formEquipamento.valid" class="form-text text-danger pl-2">
              <small *ngIf="formEquipamento.get('numeroSerie').hasError('notUniquens')">Nº de série já
                utilizado</small>
            </section>
          </div>
        </div>
      </div>


      <div class="form-row">
        <div class="col-md-12">
          <div class="position-relative form-group">
            <label for="">Descrição</label>
            <textarea row="2" class="form-control" type="text" formControlName="descricao" maxlength="40"></textarea>
          </div>
        </div>
      </div>

      <div class="form-row">
        
        <div class="col-md-12">
          <div class="position-relative form-group">
            <label for="">Local de Trabalho</label>
            <select class="form-control" [value]="this.formEquipamento.get('localId').value" disabled>
              <option *ngFor="let l of locaisPorNivel" value="{{ l.id }}">{{ l.nome }}</option>
            </select>
          </div>
        </div>
      </div>

      <div class="form-row">

        <div class="col-md-4">
          <div class="position-relative form-group">
            <label for="">Classe equipamento <span class="text-danger pl-2">(*)</span></label>
            <select for="" class="form-control" formControlName="classeEquipamentoId" required>
              <option value="">selecione</option>
              <option *ngFor="let t of this.classesEquipamento" [value]="t.id">{{ t.descricao }}</option>
            </select>
          </div>
        </div>

        


        <div class="col-md-8">
          <div class="position-relative form-group">
            <label for="">Fabricante</label>
            <div class="input-group">
              <div class="input-group">

                <select class="form-control" formControlName="fabricanteId">
                  <option *ngFor="let l of fabricantes" value="{{ l.id }}">{{ l.nome }}</option>
                </select>


                <div class="input-group-append cp" (click)="openModalCadastroFabricante(modalfabricante)"
                  title="Cadastro Fabricante">
                  <span class="input-group-text"><i class="fa fa-plus-circle"></i></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </form>
  </div>
  <div class="modal-footer">

    <div class="col-md-4"></div>
    <div class="col-md-4">
      <button type="button" class="btn btn-secondary btn-block" (click)="c('Close click')">Cancelar</button>
    </div>
    <div class="col-md-4">
        <button type="submit" class="btn btn-primary btn-block btn-shadow" form="formEquipamento">
          <i class="fa fa-plus pull-left pt-1"></i>Cadastrar
        </button>
    </div>
  </div>

</ng-template>


<!-- MODAL ÁREA TÉCNICA -->

<ng-template #modaloutraareatecnica let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">Cadastro Outra Área Técnica</h4>
  </div>
  <div class="modal-body">
    <form novalidate [formGroup]="formAreaTecnica" id="formAreaTecnica" (validSubmit)="novaAreaTecnica(c)">

      <div class="form-row">
        <div class="col-md-12">
          <div class="position-relative form-group">
            <label for="">Nome</label>
            <input class="form-control" type="text" formControlName="nome" maxlength="20" />
            <section *ngIf="!formAreaTecnica.valid" class="form-text text-danger pl-2">
              <small *ngIf="formAreaTecnica.get('nome').hasError('notUnique')">Nome de Área Técnica já utilizado</small>
            </section>
          </div>
        </div>
      </div>

    </form>
  </div>
  <div class="modal-footer">

    <div class="col-md-2"></div>
    <div class="col-md-4">
      <button type="button" class="btn btn-secondary btn-block" (click)="c('Close click')">Cancelar</button>
    </div>
    <div class="col-md-6">
        <button type="submit" class="btn btn-primary btn-block btn-shadow" form="formAreaTecnica">
          <i class="fa fa-plus pull-left pt-1"></i>Cadastrar
        </button>
    </div>

  </div>
</ng-template>


<!-- CADASTRO FABRICANTE -->

<ng-template #modalfabricante let-c="close" let-d="dismiss">

  <div class="modal-header">
    <h4 class="modal-title">Cadastro Fabricante</h4>
  </div>

  <div class="modal-body">


    <form novalidate [formGroup]="formFabricante" id="formFabricante" (validSubmit)="addFabricante(c)">

      <div class="form-row">
        <div class="col-md-12">
          <div class="position-relative form-group">
            <label for="">Nome</label>
            <input class="form-control" type="text" formControlName="nome" maxlength="50" />
            <section *ngIf="!formFabricante.valid" class="form-text text-danger pl-2">
              <small *ngIf="formFabricante.get('nome').hasError('notUnique')">Nome de fabricante já utilizado</small>
            </section>
          </div>
        </div>
      </div>

    </form>
  </div>
  <div class="modal-footer">

    <div class="col-md-2"></div>
    <div class="col-md-4">
      <button type="button" class="btn btn-secondary btn-block" (click)="c('Close click')">Cancelar</button>
    </div>
    <div class="col-md-6">
        <button type="submit" class="btn btn-primary btn-block btn-shadow" form="formFabricante">
          <i class="fa fa-plus pull-left pt-1"></i>Cadastrar
        </button>
    </div>
  </div>

</ng-template>


<ng-template #modalExibePhoto let-c="close" let-d="dismiss">
  <div class="modal-body" style="padding: 0px; background-color: #141518;">
    <div class="row">
      <div class="col-md-12 text-center" style="padding:10px; background: #141518 ;">
        <img [src]="previewPhotoSelecionada.dataUrl" class="img-thumbnail">
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12" style="padding:10px; background: #141518 ;">
      <div class="text-right">
        <button type="button" class="btn btn-secondary pl-5 pr-5 mr-4" (click)="c('Close click')">Fechar</button>
      </div>
    </div>
  </div>
</ng-template>